module.exports = __webpack_public_path__ + "2cce9193b1049d5b7d0b6e6bcf41a159.svg";